import { useEffect } from 'react'

interface Props {
  message: string
  actionLabel: string
  onAction: () => void
  onDismiss: () => void
  timeoutMs?: number
}

/** Long enough to catch a mistap, short enough not to sit there staring at you. */
export function Snackbar({ message, actionLabel, onAction, onDismiss, timeoutMs = 5_000 }: Props) {
  useEffect(() => {
    const id = setTimeout(onDismiss, timeoutMs)
    return () => clearTimeout(id)
  }, [onDismiss, timeoutMs, message])

  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 bottom-16 z-40 flex justify-center px-4 sm:bottom-6"
    >
      <div className="pointer-events-auto flex items-center gap-3 rounded-xl border border-line-strong bg-raised px-3 py-2 shadow-lg">
        <span className="text-[14px] text-text">{message}</span>
        <button
          type="button"
          onClick={onAction}
          className="rounded-md px-2 py-1 text-[14px] font-semibold text-accent transition-colors duration-150 hover:text-text"
        >
          {actionLabel}
        </button>
      </div>
    </div>
  )
}
